import { useEffect, useState } from 'react'

import { getAllOfflineEpisodes, getOfflineEpisodesByProduct, type OfflineEpisode } from '@/lib/db'
import { useDownloadStore } from '@/store/useDownloadStore'

/**
 * ダウンロード済みエピソードを読み込む（未取得のうちは null）
 *
 * productId を渡すとそのアルバム分だけを取得する。
 * ダウンロード完了・削除に追従するため、完了済み件数の変化を監視して取り直す。
 */
export const useOfflineEpisodes = (productId?: number): OfflineEpisode[] | null => {
  const [episodes, setEpisodes] = useState<OfflineEpisode[] | null>(null)
  const doneCount = useDownloadStore((s) => {
    let count = 0
    for (const info of s.downloads.values()) {
      if (info.status === 'done') count++
    }
    return count
  })

  useEffect(() => {
    let cancelled = false
    const load = productId === undefined ? getAllOfflineEpisodes() : getOfflineEpisodesByProduct(productId)
    load
      .then((rows) => {
        if (cancelled) return
        setEpisodes(rows)
      })
      .catch(() => {
        if (cancelled) return
        setEpisodes([])
      })
    return () => {
      cancelled = true
    }
  }, [productId, doneCount])

  return episodes
}
